import React from "react";
import PropTypes from "prop-types";
import {css} from "@emotion/css";
import {convertCurrencyFormatPositiveNegative, convertToMobileNumber} from "../../util/numberConvertor";
import RaikoMaterialOutlinedInput from "../raikoInputs/RaikoMaterialOutlinedInput";

const RaikoMoneyInputOutlined = (
    {
        labelText = "",
        placeHolder = "",
        value,
        setValue,
        className,
        disabled
    }
) => {


    return (
        <RaikoMaterialOutlinedInput
            placeHolder={placeHolder}
            labelText={labelText}
            className={`
            ${
                css`
                  direction: ltr;
                  text-align: end;
                `
            } ${
                className
            }`}
            disabled={disabled}
            value={convertCurrencyFormatPositiveNegative(value)}
            onChange={({target}) => {
                const unConvertedValue = target.value.replaceAll(",", "")
                if (unConvertedValue <= 999999999999999) {
                    const _value = convertCurrencyFormatPositiveNegative(unConvertedValue)
                    setValue(_value.replaceAll(",", ""))
                }
            }}/>
    )
}

RaikoMoneyInputOutlined.propTypes = {
    placeHolder: PropTypes.string,
    disabled: PropTypes.bool,
    labelText: PropTypes.string.isRequired,
    value: PropTypes.object.isRequired,
    setValue: PropTypes.func.isRequired
}

export default RaikoMoneyInputOutlined